(function () {
    var devices = {
        isIE11OrLess: function () {
            var docMode = document.documentMode;
            if (!docMode) return false;
            if (docMode <= 11) return true;
        }
    };

    function getInnerHeight($el) {
        var style = window.getComputedStyle($el, null);
        return parseInt(style.getPropertyValue("height").split("px")[0], 10);
    }

    /**
    * Ensures items in $items array are same height
    * @param $items
    * @param justClear
    */
    function sameHeightItems($items, justClear) {

        var h = 0;

        $.each($items, function (i, $el) {
            $el.removeAttribute("style");
        });

        if (justClear) return;

        $.each($items, function (i, $el) {
            //let thisH: number = getInnerHeight($el);
            var thisH = devices.isIE11OrLess() ? $($el).height() : getInnerHeight($el);
            if (thisH > h) h = thisH;
        });

        $.each($items, function (i, $el) {
            $el.style.height = h + "px";
        });
    }

    /**
    * @description Takes a list of elements and ensures they are the same height on the same row. Styles are added within inline JS.
    * @param $list (element list) - list of elements to be used.
    * @param justClear
    */
    function setFakeRowHeights($list, justClear) {
        var offTop
          , prevTop
          , itemPerRow = 0
          , rowList = []
          , multiList = [];


        $.each($list, function (i, $tile) {
            //var offTop = $tile.offsetTop;
            var offTop = $($tile).offset().top;

            if (itemPerRow) {
                //push to multilist if it has reached the the total of items per row
                if (i % itemPerRow == 0) {
                    multiList.push(rowList);
                    rowList = [];
                }

                rowList.push($tile);

            } else {
                // if offsetTop is different, means it's a new line
                if (i > 0 && prevTop !== offTop) {
                    //find total items per row first based on offsetTop
                    itemPerRow = rowList.length;
                    multiList.push(rowList);
                    rowList = [];
                }

                rowList.push($tile);
            }

            prevTop = offTop;

            //push the rest of items to multilist
            if (i == $list.length - 1) multiList.push(rowList);

        });

        $.each(multiList, function (i, row) {
            if (row.length > 1) sameHeightItems(row, justClear);
            else sameHeightItems(row, true); //if only one tile is left, remove attribue 'style'
        });
    }

    function debounce(func, wait, immediate) {
        var timeout;

        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    function groupBy(arr, key) {
      return arr.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    }

    function replaceNullValue(oriVal, newVal) {
        if(oriVal == "" || oriVal == null) newVal = newVal ? newVal : "";
        else newVal = oriVal;

        return newVal;
    }

    function renderErrorMsg($target, msg) {
        var tmpl = '<div class="glbError">' + msg + '</div>';
        var $error = $target.find('.glbError');
        if ($error.length) $error.html(msg);
        else $target.prepend(tmpl);
    }

    function addIEClasses ($siteWrap) {
        // Just in case you need to browser sniff MS IE11 browser
        if (devices.isIE11OrLess()) $siteWrap.addClass('ie-msie11');
    }

    function isAgedCare() {
        return $('body').hasClass('is-agedCare');
    }

    function isWholesale() {
        return $('#product-detail').hasClass('product-detail--wholesale');
    }

    function isCheckLocalStockAsync() {        
        return `${$('#product-detail').data('check-local-stock-async')}`?.toLowerCase() === "true";
    }

    function isPlp() {
        return $('#product-listing').length > 0;
    }

    function isOnMouse() {
        document.body.addEventListener('mousedown', function() {
            document.body.classList.add('using-mouse');
        });

        document.body.addEventListener('keydown', function() {
            document.body.classList.remove('using-mouse');
        });
    }

    function isElementInViewport (el) {

      // Special bonus for those using jQuery
      if (typeof jQuery === "function" && el instanceof jQuery) {
          el = el[0];
      }

      var rect = el.getBoundingClientRect();

      return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
          rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
      );
    }

    function uploadBase64Image(base64String) {
        // Split the base64 string in data and contentType
        var block = base64String.split(";");
        // Get the content type
        var contentType = block[0].split(":")[1];
        // Get the real base64 content of the file
        var realData = block[1].split(",")[1];
        // Convert to blob
        var blob = b64toBlob(realData, contentType);
        // Create a FormData and append the file
        // var formData = new FormData();
        // formData.append("file", blob);
        // Now you can send the form using fetch or XMLHttpRequest
        return blob;
    }

    function b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        var blob = new Blob(byteArrays, {type: contentType});
        return blob;
    }

    function isEmpty(content) {
        return content === '' || content === null || content === 'null' || content === undefined || content === 'undefined';
    }

    var Utils = {
        Debounce: debounce
      , setFakeRowHeights: setFakeRowHeights
      , groupBy: groupBy
      , replaceNullValue: replaceNullValue
      , renderErrorMsg: renderErrorMsg
      , addIEClasses: addIEClasses
      , isAgedCare: isAgedCare
      , isWholesale: isWholesale
      , isOnMouse: isOnMouse
      , isElementInViewport: isElementInViewport
      , uploadBase64Image: uploadBase64Image
      , isCheckLocalStockAsync: isCheckLocalStockAsync
      , isEmpty: isEmpty
      , isPlp: isPlp
    };

    Core = Core || {};
    Core.Util = Utils;
})();

/*
Core.Util = {
    // debouce - a la Underscore

    Debounce: function (func, wait, immediate) {
        var timeout;

        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }
};
*/
